<div>
    <h5 mat-dialog-title class="modal_title flex">
        {{currentProvider == 'chooseSource' ? 'Choose your data source' : currentProvider == 'addProspect' ?
        ('LEAD_MANAGEMENT.ADD_PROSPECT' | translate) : ('CAMPAIGN.MOVE_FROM_LIST' | translate)}}
        <mat-icon svgIcon="mat_outline:close"
            class="ml-auto max-w-[22px] max-h-[22px] text-[#0b0d13] font-medium cursor-pointer leading-none min-w-[22px] text-[22px] min-h-[22px]"
            mat-dialog-close></mat-icon>
    </h5>
    <mat-dialog-content *ngIf="activaPage != 'campaign_prospecting'">
        <a *ngIf="currentProvider != 'chooseSource'"
            class="mb-[14px] mt-2 flex cursor-pointer items-center text-primary"
            (click)="currentProvider = 'chooseSource'"><i class="ri-arrow-left-s-line mr-1.5"></i>{{
            "SETTING_PAGE.BACK" | translate }}</a>
        <div *ngIf="currentProvider == 'chooseSource'" class="pt-5">
            <ng-container [ngTemplateOutlet]="inProgress"></ng-container>
            <div class="h-full grid gap-5"
                [ngClass]="{'grid-cols-1 sm:grid-cols-2 ': (activaPage == 'prospecting' || (activaPage == 'prospect_management' && _mapping.type == 'campaign')), 'grid-cols-1': (activaPage == 'prospect_management' && _mapping.type == 'list')}">
                <div class="flex flex-col h-full">
                    <div class="flex items-center justify-between mb-2.5">
                        <h5 class="text-lg font-medium leading-5 text-[#0B0D13]">{{"CAMPAIGN.BULK_UPLOAD" | translate}}
                        </h5>
                        <div class="text-primary underline text-base font-normal leading-5 cursor-pointer"
                            (click)="_prospectService?.downloadSampleFile($event)">
                            {{"CAMPAIGN.DOWNLOAD_SAMPLE_CSV" | translate}}
                        </div>
                    </div>
                    <div class="max-h-[150px] w-full bg-primary/5 border-primary"
                        [ngClass]="{'pointer-events-none opacity-60': _mapping?.isLodingMapping}" ngx-dropzone
                        #selectFile [accept]="'.csv'" (change)="_mapping.handleFile($event)" [multiple]="false">
                        <!-- *ngIf="!brandImages.logo" -->
                        <ngx-dropzone-label class="z-0 my-[18px]">
                            <div class="flex flex-col">
                                <i class="ri-upload-cloud-2-line mb-3 text-primary text-4xl"></i>
                                <h2 class="text-[#0B0D13] text-md leading-normal font-medium mb-0">
                                    {{"EMAIL_MARKETING.DRAG_AND_DROP_FILE" | translate}} {{"EMAIL_MARKETING.OR" |
                                    translate}}
                                    <span class="text-primary text-md leading-normal underline">
                                        {{"EMAIL_MARKETING.BROWSE" |
                                        translate}}</span>
                                </h2>
                                <p class="mb-0 text-[#0B0D13] text-sm leading-normal">
                                    {{"EMAIL_MARKETING.TO_UPLOAD_FILE" | translate}}
                                </p>
                            </div>
                        </ngx-dropzone-label>
                    </div>
                </div>
                <ng-container
                    *ngIf="(activaPage == 'prospecting' || (activaPage == 'prospect_management' && _mapping.type == 'campaign'))"
                    [ngTemplateOutlet]="prospectFinder"></ng-container>
            </div>
            <div class="grid gap-5 mt-8 grid-cols-1 sm:grid-cols-2">
                <ng-container *ngIf="(activaPage == 'prospect_management' && _mapping.type == 'list')"
                    [ngTemplateOutlet]="prospectFinder"></ng-container>
                <div (click)="openSource('addProspect')"
                    class="bg-[#F8F8FB] border border-transparent hover:border-primary rounded-[5px] px-[22px] py-[30px] cursor-pointer transition-all">
                    <div class="flex items-start gap-3">
                        <div
                            class="bg-primary/10 h-[40px] w-[40px] min-h-[40px] min-w-[40px] flex items-center justify-center rounded-full">
                            <i class="fa-solid fa-user text-lg text-primary"></i>
                        </div>
                        <div class="flex flex-col">
                            <h5 class="text-[#0B0D13] mb-2.5 text-base font-medium leading-[18px]">
                                {{"CAMPAIGN.ADD_SINGLE_PROSPECT" | translate}}
                            </h5>
                            <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                                {{"CAMPAIGN.ADD_AN_INDIVIDUAL_PROSPECT_TO_YOUR_CAMPAIGN" | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="(activaPage == 'prospecting' || (activaPage == 'prospect_management' && _mapping.type == 'campaign'))"
                    [tooltip]="_prospectService?.allLists?.length == 0 ? 'Create a list in Prospect Management to use this feature.' : ''"
                    [zIndex]="1190" (click)="_prospectService?.allLists?.length > 0 ? openSource('moveProspect') : ''">
                    <div [ngClass]="{'pointer-events-none opacity-60': _prospectService?.allLists?.length == 0}"
                        class="bg-[#F8F8FB] border border-transparent hover:border-primary rounded-[5px] px-[22px] py-[30px] cursor-pointer transition-all">
                        <div class="flex items-start gap-3">
                            <div
                                class="bg-primary/10 h-[40px] w-[40px] min-h-[40px] min-w-[40px] flex items-center justify-center rounded-full">
                                <i class="fa-solid fa-user-group text-lg text-primary"></i>
                            </div>
                            <div class="flex flex-col">
                                <h5 class="text-[#0B0D13] mb-2.5 text-base font-medium leading-[18px]">
                                    {{"CAMPAIGN.MOVE_FROM_LIST" | translate }}</h5>
                                <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                                    {{"CAMPAIGN.GOT_A_READY_LIST_OF_PROSPECTS_READY_IN_PROSPECT_MANAGEMENT" |
                                    translate}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-container [ngTemplateOutlet]="addProspect"></ng-container>
        <ng-container [ngTemplateOutlet]="moveProspect"></ng-container>
    </mat-dialog-content>

    <mat-dialog-content *ngIf="activaPage == 'campaign_prospecting'">
        <a *ngIf="currentProvider != 'chooseSource'"
            class="mb-[14px] mt-2 flex cursor-pointer items-center text-primary"
            (click)="currentProvider = 'chooseSource'"><i class="ri-arrow-left-s-line mr-1.5"></i>{{
            "SETTING_PAGE.BACK" | translate }}</a>
        <div *ngIf="currentProvider == 'chooseSource'" class="pt-5">
            <ng-container [ngTemplateOutlet]="inProgress"></ng-container>
            <div class="flex flex-col gap-3">
                <div class="flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <h5 class="text-md leading-4 font-medium text-[#0B0D13]">{{"CAMPAIGN.BULK_UPLOAD" | translate}}
                        </h5>
                        <div class="text-primary underline font-medium leading-4 text-md cursor-pointer"
                            (click)="_prospectService?.downloadSampleFile($event)">
                            {{"CAMPAIGN.DOWNLOAD_SAMPLE_CSV" | translate}}
                        </div>
                    </div>
                    <div class="max-h-[70px] w-full bg-primary/8 border-primary"
                        [ngClass]="{'pointer-events-none opacity-60': _mapping?.isLodingMapping}" ngx-dropzone
                        #selectFile [accept]="'.csv'" (change)="_mapping.handleFile($event)" [multiple]="false">
                        <ngx-dropzone-label class="z-0">
                            <div class="flex flex-row items-start gap-2.5">
                                <i class="ri-upload-cloud-2-line text-primary text-4xl"></i>
                                <div class="flex flex-col items-start gap-1.5">
                                    <h2 class="text-[#0B0D13] text-md leading-4 font-normal">
                                        {{"EMAIL_MARKETING.DRAG_AND_DROP_FILE" | translate}} {{"EMAIL_MARKETING.OR" |
                                        translate}}
                                        <span class="text-primary underline">
                                            {{"EMAIL_MARKETING.BROWSE" |
                                            translate}}</span>
                                    </h2>
                                    <p class="text-[#7D7F86] text-sm leading-4 font-normal">
                                        {{"EMAIL_MARKETING.TO_UPLOAD_FILE" | translate}}
                                    </p>
                                </div>
                            </div>
                        </ngx-dropzone-label>
                    </div>
                </div>
                <div [routerLink]="'/prospect-finder'" (click)="_dialog?.closeAll()"
                    class="bg-[#F8F8FB] p-4 rounded-md cursor-pointer">
                    <div class="flex items-start gap-2.5">
                        <div
                            class="bg-primary/10 h-8 w-8 min-h-8 min-w-8 flex items-center justify-center rounded-full">
                            <i class="ri-user-search-line text-[20px] text-primary"></i>
                        </div>
                        <div class="flex flex-col gap-2.5">
                            <h5 class="text-[#0B0D13] text-base font-medium leading-[18px]">
                                {{"PROSPECT_FINDER.IMPORT_WITH_LEAD_FINDER" | translate}}
                            </h5>
                            <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                                {{"PROSPECT_FINDER.PICK_THE_FILTERED" | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- <div class="bg-[#F8F8FB] p-4 rounded-md cursor-pointer">
                    <div class="flex items-start gap-2.5">
                        <div
                            class="bg-primary/10 h-8 w-8 min-h-8 min-w-8 flex items-center justify-center rounded-full">
                            <i class="ri-linkedin-box-line text-[20px] text-primary"></i>
                        </div>
                        <div class="flex flex-col gap-2.5">
                            <h5 class="text-[#0B0D13] text-base font-medium leading-[18px]">
                                {{"Import Linkedin Leads" | translate}}
                            </h5>
                            <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                                {{"Pick the filtered & matching prospects from a Linkedin" | translate}}
                            </p>
                        </div>
                    </div>
                </div> -->
                <div (click)="openSource('addProspect')" class="bg-[#F8F8FB] rounded-md cursor-pointer p-4">
                    <div class="flex items-start gap-3">
                        <div
                            class="bg-primary/10 h-8 w-8 min-h-8 min-w-8 flex items-center justify-center rounded-full">
                            <i class="ri-user-line text-[20px] text-primary"></i>
                        </div>
                        <div class="flex flex-col gap-2.5">
                            <h5 class="text-[#0B0D13] text-base font-medium leading-[18px]">
                                {{"CAMPAIGN.ADD_SINGLE_PROSPECT" | translate}}
                            </h5>
                            <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                                {{"CAMPAIGN.ADD_AN_INDIVIDUAL_PROSPECT_TO_YOUR_CAMPAIGN" | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div [tooltip]="_prospectService?.allLists?.length == 0 ? 'Create a list in Prospect Management to use this feature.' : ''"
                    [zIndex]="1190" (click)="_prospectService?.allLists?.length > 0 ? openSource('moveProspect') : ''">
                    <div [ngClass]="{'pointer-events-none opacity-60': _prospectService?.allLists?.length == 0}"
                        class="bg-[#F8F8FB] p-4 rounded-md cursor-pointer">
                        <div class="flex items-start gap-2.5">
                            <div
                                class="bg-primary/10 h-8 w-8 min-h-8 min-w-8 flex items-center justify-center rounded-full">
                                <i class="ri-group-line text-[20px] text-primary"></i>
                            </div>
                            <div class="flex flex-col gap-2.5">
                                <h5 class="text-[#0B0D13] text-base font-medium leading-[18px]">
                                    {{"CAMPAIGN.MOVE_FROM_LIST" | translate }}</h5>
                                <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                                    {{"CAMPAIGN.GOT_A_READY_LIST_OF_PROSPECTS_READY_IN_PROSPECT_MANAGEMENT" |
                                    translate}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-container [ngTemplateOutlet]="addProspect"></ng-container>
        <ng-container [ngTemplateOutlet]="moveProspect"></ng-container>
        
    </mat-dialog-content>

    <mat-dialog-actions *ngIf="currentProvider == 'moveProspect'" align="start" class="form_action">
        <btn-loading (click)="moveListToCampaign()"
            [ngClass]="{'pointer-events-none opacity-60': !_prospectService.selectedList}" type="submit" color="primary"
            btnClass="text-md text-custom font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded"
            [loading]="isMoveCampaign">
            {{ "CAMPAIGN.MOVE" | translate }}
        </btn-loading>
        <button matRipple class="cancel_btn" *ngIf="!isMoveCampaign" mat-dialog-close>
            {{ "GENERAL.CANCEL" | translate }}
        </button>
    </mat-dialog-actions>
    <mat-dialog-actions *ngIf="currentProvider == 'addProspect'" align="start" class="form_action">
        <btn-loading type="submit" color="primary" (click)="doAddProspect()" [loading]="isAddProspect"
            btnClass="text-md text-custom font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded">
            {{"LEAD_MANAGEMENT.ADD" | translate}}
        </btn-loading>
        <button matRipple class="cancel_btn" mat-dialog-close>
            {{ "GENERAL.CANCEL" | translate }}</button>
    </mat-dialog-actions>
</div>

<ng-template #inProgress>
    <div [ngClass]="{'mt-5': _prospectService?.prospectsData && (_prospectService?.prospectsData?.tot_accepted || _prospectService?.prospectsData?.tot_new_contacts), 'mb-5' : _prospectService?.prospectsData && (!_prospectService?.prospectsData?.tot_accepted && !_prospectService?.prospectsData?.tot_new_contacts)}"
        *ngIf="_mapping?.isLodingMapping">
        <div class="flex items-center justify-between mb-1 loading">
            <p class="text-primary font-medium text-md leading-5">{{ "CAMPAIGN.FILE_IMPORTING" |
                translate
                }}<span></span></p>
            <p class="text-primary font-medium text-md leading-5 text-end ">{{progressbarLoading?.progress
                ??
                0}}%</p>
        </div>
        <mat-progress-bar class="rounded" [value]="progressbarLoading?.progress == 0 ? 1 : progressbarLoading?.progress"
            mode="determinate"></mat-progress-bar>
    </div>
</ng-template>

<ng-template #prospectFinder>
    <div class="flex flex-col h-full">
        <div *ngIf="_mapping.type != 'list'" class="sm:flex items-center justify-between mb-2.5 hidden sm:invisible">
            <h5 class="text-lg font-medium leading-5 text-[#0B0D13]">
                {{"CAMPAIGN.BULK_UPLOAD" | translate}}
            </h5>
            <div class="text-primary underline text-base font-normal leading-5 cursor-pointer">
                {{"CAMPAIGN.DOWNLOAD_SAMPLE_CSV" | translate}}
            </div>
        </div>
        <div [routerLink]="'/prospect-finder'" (click)="_dialog?.closeAll()"
            class="bg-[#F8F8FB] border border-transparent hover:border-primary rounded-[5px] px-[22px] py-[30px] cursor-pointer transition-all flex-1">
            <div class="flex items-start gap-3">
                <div
                    class="bg-primary/10 h-[40px] w-[40px] min-h-[40px] min-w-[40px] flex items-center justify-center rounded-full">
                    <i class="ri-user-search-line text-lg text-primary"></i>
                </div>
                <div class="flex flex-col">
                    <h5 class="text-[#0B0D13] mb-2.5 text-base font-medium leading-[18px]">
                        {{"PROSPECT_FINDER.IMPORT_WITH_LEAD_FINDER" | translate}}
                    </h5>
                    <p class="text-[#7D7F86] text-md leading-[17px] font-normal">
                        {{"PROSPECT_FINDER.PICK_THE_FILTERED" | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #addProspect>
    <div class="pt-5" *ngIf="currentProvider == 'addProspect'">
        <form [formGroup]="profileForm" #profile>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-4">
                <div
                    *ngFor="let field of sortedFields | slice : 0 : (!showHideField ? 15 : sortedFields?.length) ; let i = index">
                    <div class="mail-name-input form-group relative" [ngClass]="{'gap-x-3 gap-y-4': i < 15}">
                        <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" floatLabel="always">
                            <mat-label class="form_label"> {{field?.column_value}}<span *ngIf="field?.column_key == 'email'"
                                    class="text-red-500 ml-0.5">*</span></mat-label>
                            <input *ngIf="field?.created_type?.toLowerCase() == 'default'" type="text"
                                id="{{field?.column_key}}" name="{{field?.column_key}}" class="w-full form_input rounded-3"
                                formControlName="{{ field.column_key }}" matInput />
                            <textarea *ngIf="field?.created_type?.toLowerCase() == 'custom'" id="{{field?.column_key}}"
                                name="{{field?.column_key}}" class="w-full !m-0 resize-y"
                                formControlName="{{ field.column_key }}" matInput rows="1" [cdkTextareaAutosize]="false"
                                style="max-height: 150px;">
                                </textarea>
                            <mat-error *ngIf="profileForm.get(field.column_key).hasError('email')">
                                {{"LEAD_MANAGEMENT.ENTER_VALID_EMAIL_ADDRESS" | translate}}
                            </mat-error>
                            <mat-error *ngIf="profileForm.get(field.column_key).hasError('pattern')">
                                {{field?.column_key == 'linkedin' ?
                                ('LEAD_MANAGEMENT.PLEASE_ENATER_VALID_LINKEDIN_URL' | translate) :
                                field?.column_key == 'twitter' ?
                                ('LEAD_MANAGEMENT.PLEASE_ENTER_A_VALID_TWITTER_URL' | translate) :
                                field?.column_key == 'facebook' ?
                                ('LEAD_MANAGEMENT.PLEASE_ENTER_A_VALID_FACEBOOK_URL' | translate) :
                                field?.column_key == 'website' ?
                                ('LEAD_MANAGEMENT.PLEASE_ENTER_A_VALID_WEBSITE_URL' | translate) :
                                field?.column_key == 'phone' ?
                                ('LEAD_MANAGEMENT.PLEASE_ENTER_A_VALID_NUMBER' | translate) : ''}}
                            </mat-error>
                            <mat-hint class="mat-error"
                                *ngIf="profileForm?.controls?.email?.errors?.lv && field.column_key == 'email'">{{profileForm?.controls?.email?.getError("lv")}}</mat-hint>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <button *ngIf="sortedFields?.length > 15" (click)="toggleFiledShowHide()"
                class="text-primary text-md font-medium mt-5">
                {{ showHideField ? ('LEAD_MANAGEMENT.SHOW_LESS_FIELDS' | translate) :
                ('LEAD_MANAGEMENT.SHOW_MORE_FIELDS' | translate) }}
            </button>
        </form>
    </div>
</ng-template>

<ng-template #moveProspect>
    <div *ngIf="currentProvider == 'moveProspect'">
        <mat-label class="form_label text-base text-[#0B0D13]" for="move_campaign">Select one of your
            list</mat-label>
        <mat-form-field class="w-full fuse-mat-dense mt-1" subscriptSizing="dynamic" floatLabel="always">
            <mat-select id="move_campaign" name="move_campaign" [(ngModel)]="_prospectService.selectedList">
                <mat-option *ngFor="let list of _prospectService?.allLists" [value]="list?.id"
                    class="min-h-[38px] whitespace-nowrap">
                    {{list?.name}}
                </mat-option>
                <mat-option *ngIf="_prospectService?.allLists?.length == 0"
                    class="min-h-[38px] whitespace-nowrap pointer-events-none opacity-60">
                    No list found
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-checkbox class="campaign-checkBox mt-3 -ml-2.5" [(ngModel)]="_prospectService.isCheckDuplicate">
            Check for duplicates across all lists</mat-checkbox>
    </div>
</ng-template>